var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details-view" },
    [
      _c(
        "cargo-left-right-resize",
        {
          staticStyle: { "min-height": "100%" },
          attrs: {
            "left-style": {
              flex: "none",
              "min-width": "180px",
              "max-width": "220px"
            },
            "right-style": { overflow: "hidden" },
            "show-left": _vm.action === "look"
          }
        },
        [
          _c(
            "template",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.action === "look",
                  expression: "action==='look'"
                }
              ],
              slot: "left"
            },
            [
              _c("cargo-ag-grid", {
                staticClass: "section",
                staticStyle: {
                  "min-width": "160px",
                  width: "100%",
                  height: "100%"
                },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.gridOptions,
                  "row-data": _vm.rowData,
                  "check-sub-record": false,
                  "check-main-record": false,
                  "deselect-main-record": false,
                  "deselect-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c("template", { slot: "right" }, [
            _c("div", { staticClass: "main-content" }, [
              _vm.$store.getters.enableFrontEndPlugin
                ? _c(
                    "div",
                    [
                      _c("micro-app", {
                        attrs: {
                          name: "child-sale-role-hide-salesquery",
                          url:
                            _vm.$store.getters.frontEndPluginUrl +
                            "/saleRoleHideItem",
                          "router-mode": "pure",
                          destroy: ""
                        },
                        on: { datachange: _vm.saleRoleHideDataChange }
                      }),
                      _c("micro-app", {
                        attrs: {
                          name: "child-customer-sales-display-salesquery",
                          url:
                            _vm.$store.getters.frontEndPluginUrl +
                            "/customerSalesDisplayItem",
                          "router-mode": "pure",
                          destroy: ""
                        },
                        on: { datachange: _vm.customerSalesDisplayDataChange }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "div",
                {
                  staticClass: "operations",
                  staticStyle: { "margin-bottom": "5px" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "triggers" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "1", type: "primary" },
                          on: { click: _vm.goBack }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ReturnQuery")))]
                      ),
                      _vm._l(_vm.instructioinBtns, function(item, index) {
                        return [
                          _c(
                            "el-button",
                            {
                              key: index,
                              attrs: {
                                no: item.platformInstructionRuleCode,
                                type: "primary",
                                disabled: !item.allowOperate
                              },
                              on: {
                                click: function($event) {
                                  return _vm.onInstructionClick(item)
                                }
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$selectByLang(
                                      item.chineseName,
                                      item.englishName,
                                      item.japaneseName
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ]
                      }),
                      _vm.activeTabName === "tabInternalBill" ||
                      _vm.activeTabName === "tabCharges"
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "2", type: "success" },
                              on: { click: _vm.onPrint }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                          )
                        : _vm._e(),
                      _vm.showOverSeaPrint
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "3", type: "success" },
                              on: { click: _vm.onPrint }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.print")))]
                          )
                        : _vm._e(),
                      _vm.editSaleInfo &&
                      _vm.currentRow &&
                      _vm.currentRow.lob === "SE"
                        ? _c(
                            "el-button",
                            {
                              attrs: {
                                no: "4",
                                disabled:
                                  !_vm.currentRow ||
                                  Number(_vm.currentRow.jobState) != 0,
                                type: "primary"
                              },
                              on: { click: _vm.onEditSaleInfo }
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("CargoMsg.Cargo_EditSaleInfo"))
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm.$checkPermission(["button_ledger"])
                        ? _c(
                            "el-button",
                            {
                              attrs: { no: "9", type: "primary" },
                              on: { click: _vm.toUnlockApply }
                            },
                            [_vm._v(_vm._s(_vm.$t("SeaExport.UnlockApplyBtn")))]
                          )
                        : _vm._e()
                    ],
                    2
                  ),
                  _c(
                    "div",
                    { staticClass: "triggers-right" },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "red",
                          staticStyle: { "font-size": "14px" },
                          attrs: { no: "JobState" }
                        },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.ColumnUtils.getJobState(_vm.currentRow)
                              ) +
                              " "
                          ),
                          (_vm.currentRow.jobState === 0 ||
                            _vm.currentRow.jobState === 1 ||
                            _vm.currentRow.jobState === 2 ||
                            _vm.currentRow.jobState === 11) &&
                          _vm.currentRow.shutOut
                            ? _c(
                                "font",
                                {
                                  staticClass: "red",
                                  staticStyle: {
                                    "font-size": "14px",
                                    "margin-left": "4px"
                                  }
                                },
                                [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.$t("Message.HasChargeToShutOut")
                                      ) +
                                      ")"
                                  )
                                ]
                              )
                            : _vm._e(),
                          _vm.currentRow.payableChargeLockedStatus === 1
                            ? _c(
                                "span",
                                { staticStyle: { "margin-left": "6px" } },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "CargoMsg.Cargo_PayableLockedStatusTag"
                                      )
                                    )
                                  ),
                                  _c(
                                    "el-tooltip",
                                    {
                                      attrs: {
                                        effect: "dark",
                                        content: _vm.payableChargeLockedTooltip,
                                        placement: "bottom",
                                        "visible-arrow": false
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-warning",
                                        staticStyle: { cursor: "pointer" }
                                      })
                                    ]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm.currentRow.payableChargeLockedStatus === 1
                        ? _c(
                            "span",
                            { staticStyle: { "margin-left": "6px" } },
                            [
                              _vm._v(
                                _vm._s(
                                  _vm.$t(
                                    "CargoMsg.Cargo_PayableLockedStatusTag"
                                  )
                                )
                              ),
                              _c(
                                "el-tooltip",
                                {
                                  attrs: {
                                    effect: "dark",
                                    content: _vm.payableChargeLockedTooltip,
                                    placement: "bottom",
                                    "visible-arrow": false
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-warning",
                                    staticStyle: { cursor: "pointer" }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.currentRow && _vm.currentRow.uuid
                        ? [
                            _vm.salesHeaderJobNoDisplay
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "font-size": "12px",
                                      "margin-left": "10px",
                                      color: "unset"
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.salesHeaderJobNoDisplay))]
                                )
                              : _vm._e(),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "margin-left": "10px",
                                  color: "unset"
                                }
                              },
                              [_vm._v(_vm._s(_vm.salesHeaderDocNoDisplay))]
                            ),
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "12px",
                                  "margin-left": "10px",
                                  color: "unset"
                                }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.salesHeaderCustomerRefNoDisplay)
                                )
                              ]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "tabs-container" },
                [
                  _c(
                    "el-tabs",
                    {
                      ref: "tabs",
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      on: { "tab-click": _vm.handleTabClick },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      [
                        _vm.seUiCustomEnable
                          ? [
                              !_vm.isSalesForSzfs &&
                              _vm.seUiCustomShowPageSet.basic
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: "seBasicTab",
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_Operation"
                                        ),
                                        lazy: true,
                                        name: "basicTab"
                                      }
                                    },
                                    [
                                      _c("basic-tab", {
                                        ref: "basicTab",
                                        attrs: {
                                          lob: _vm.lob,
                                          "master-flag": _vm.masterFlag,
                                          context: _vm.context,
                                          job: _vm.currentRow,
                                          "show-ui-custom": true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.seUiCustomShowPageSet.vessel
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: "seVesselEqTab",
                                      attrs: {
                                        lazy: !_vm.isSalesForSzfs,
                                        name: "tabVesselEq",
                                        label: _vm.$t("CargoMsg.Cargo_Booking")
                                      }
                                    },
                                    [
                                      _c("tab-vessel-eq-UICustom", {
                                        ref: "tabVesselEq",
                                        attrs: {
                                          context: _vm.context,
                                          action: _vm.action,
                                          "view-source": "salesDetail",
                                          "is-sales-for-szfs":
                                            _vm.isSalesForSzfs
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          : _vm.aeUiCustomEnable
                          ? [
                              !_vm.isSalesForSzfs &&
                              _vm.aeUiCustomShowPageSet.basic
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: "aeBasicTab",
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_Operation"
                                        ),
                                        lazy: true,
                                        name: "basicTab"
                                      }
                                    },
                                    [
                                      _c("basic-tab", {
                                        ref: "basicTab",
                                        attrs: {
                                          lob: _vm.lob,
                                          "master-flag": _vm.masterFlag,
                                          context: _vm.context,
                                          job: _vm.currentRow,
                                          "show-ui-custom": true
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              !_vm.isSalesForSzfs &&
                              _vm.aeUiCustomShowPageSet.vessel
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: "aeVesselEqTab",
                                      attrs: {
                                        lazy: true,
                                        name: "tabVesselEq",
                                        label: _vm.$t("CargoMsg.Cargo_Booking")
                                      }
                                    },
                                    [
                                      _c("ae-tab-vessel-eq-UICustom", {
                                        ref: "tabVesselEq",
                                        attrs: {
                                          context: _vm.context,
                                          action: _vm.action,
                                          "view-source": "salesDetail"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                          : [
                              !_vm.isSalesForSzfs
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: 1,
                                      attrs: {
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_Operation"
                                        ),
                                        lazy: true,
                                        name: "basicTab"
                                      }
                                    },
                                    [
                                      _c("basic-tab", {
                                        ref: "basicTab",
                                        attrs: {
                                          lob: _vm.lob,
                                          "master-flag": _vm.masterFlag,
                                          context: _vm.context,
                                          job: _vm.currentRow
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.lob === "SE"
                                ? _c(
                                    "el-tab-pane",
                                    {
                                      key: 2,
                                      attrs: {
                                        lazy: !_vm.isSalesForSzfs,
                                        name: "tabVesselEq",
                                        label: _vm.$t("CargoMsg.Cargo_Booking")
                                      }
                                    },
                                    [
                                      _c("tab-vessel-eq", {
                                        ref: "tabVesselEq",
                                        attrs: {
                                          context: _vm.context,
                                          action: _vm.action,
                                          "view-source": "salesDetail",
                                          "is-sales-for-szfs":
                                            _vm.isSalesForSzfs
                                        }
                                      })
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ]
                      ],
                      _vm.lob === "IE" &&
                      _vm.currentRow.containerLoadType === "TT" &&
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 30,
                              attrs: {
                                lazy: true,
                                name: "tabGatheringTrailer",
                                label: _vm.$t("SeaExport.GatheringTrailer")
                              }
                            },
                            [
                              _c("tab-gathering-trailer", {
                                ref: "tabGatheringTrailer",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.lob === "IE" &&
                      _vm.currentRow.containerLoadType === "CL" &&
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 31,
                              attrs: {
                                lazy: true,
                                name: "tabLessThanCarload",
                                label: _vm.$t(
                                  "SeaExport.WholeVehicleLessThanCarload"
                                )
                              }
                            },
                            [
                              _c("tab-less-than-carload", {
                                ref: "tabLessThanCarload",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.lob === "IE" &&
                      _vm.currentRow.containerLoadType === "IC"
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 32,
                              attrs: {
                                lazy: !_vm.isSalesForSzfs,
                                name: "tabOrderCar",
                                label: _vm.$t("CargoMsg.Cargo_Booking")
                              }
                            },
                            [
                              _c("tab-order-car", {
                                ref: "tabOrderCar",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.seUiCustomEnable
                        ? [
                            (_vm.masterFlag || _vm.currentRow.signMBL) &&
                            _vm.seUiCustomShowPageSet.mbl
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seMBLTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabMBL",
                                      label: "MB/L"
                                    }
                                  },
                                  [
                                    _c("tab-mbl-UICustom", {
                                      ref: "tabMBL",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.currentRow.typeMBL === 2 &&
                            _vm.seUiCustomShowPageSet.mbl
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seMBLSplitTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabMBL2",
                                      label:
                                        "MB/L" +
                                        _vm.$t("CargoMsg.Cargo_SplitBL")
                                    }
                                  },
                                  [
                                    _c("tab-mbl2-UICustom", {
                                      ref: "tabMBL2",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.currentRow.typeMBL === 3 &&
                            _vm.seUiCustomShowPageSet.mbl
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seMBLMergeTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabMBL2",
                                      label:
                                        "MB/L" +
                                        _vm.$t("SeaExport.MergeAndSingle")
                                    }
                                  },
                                  [
                                    _c("tab-mbl2-UICustom", {
                                      ref: "tabMBL2",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.currentRow.signHBL &&
                            !_vm.currentRow.mblOnly &&
                            !_vm.masterFlag &&
                            _vm.seUiCustomShowPageSet.hbl
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seHBLTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabHBL",
                                      label: "HB/L"
                                    }
                                  },
                                  [
                                    _c("tab-hbl-UICustom", {
                                      ref: "tabHBL",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.currentRow.mblOnly &&
                            _vm.currentRow.typeHBL === 2 &&
                            _vm.seUiCustomShowPageSet.hbl
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seHBLSplitTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabHBL2",
                                      label:
                                        "HB/L" +
                                        _vm.$t("CargoMsg.Cargo_SplitBL")
                                    }
                                  },
                                  [
                                    _c("tab-hbl2-UICustom", {
                                      ref: "tabHBL2",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            !_vm.currentRow.mblOnly &&
                            _vm.currentRow.typeHBL === 3 &&
                            _vm.seUiCustomShowPageSet.hbl
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seHBLMergeTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabHBL2",
                                      label:
                                        "HB/L" +
                                        _vm.$t("SeaExport.MergeAndSingle")
                                    }
                                  },
                                  [
                                    _c("tab-hbl2-UICustom", {
                                      ref: "tabHBL2",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.currentRow.virtualHBL &&
                            _vm.seUiCustomShowPageSet.virtualHbl
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seSubBillTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabSubBill",
                                      label: _vm.$t("SeaExport.FormalHbl")
                                    }
                                  },
                                  [
                                    _c("tab-sub-bill-UICustom", {
                                      ref: "tabSubBill",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.currentRow &&
                      _vm.currentRow.lob &&
                      !_vm.isSalesForSzfs &&
                      !_vm.seUiCustomEnable
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 5,
                              attrs: {
                                lazy: true,
                                name: "warehouseTab",
                                label: _vm.$t("CargoMsg.Cargo_WarehouseDoor")
                              }
                            },
                            [
                              _c("warehouse-tab", {
                                ref: "warehouseTab",
                                attrs: {
                                  job: _vm.currentRow,
                                  lob: _vm.currentRow.lob,
                                  context: _vm.context,
                                  "master-flag": _vm.currentRow.masterFlag,
                                  "view-source": "salesDetail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.currentRow &&
                      _vm.currentRow.lob !== "AE" &&
                      _vm.currentRow.lob !== "AI" &&
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 6,
                              attrs: {
                                lazy: true,
                                name: "containerTab",
                                label: _vm.$t("SeaExport.ContainerInfo")
                              }
                            },
                            [
                              _c("container-tab", {
                                ref: "containerTab",
                                attrs: {
                                  job: _vm.currentRow,
                                  lob: _vm.lob,
                                  context: _vm.context,
                                  "master-flag": _vm.masterFlag,
                                  "view-source": "salesDetail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.seUiCustomEnable
                        ? [
                            _vm.currentRow.landTransportation &&
                            _vm.seUiCustomShowPageSet.trucking
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seTruckingTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabTruckingForSe",
                                      label: _vm.$t("SeaExport.Trucking")
                                    }
                                  },
                                  [
                                    _c("tab-trucking-UICustom", {
                                      ref: "tabTruckingForSe",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.currentRow.dischargingPortDoor &&
                            _vm.seUiCustomShowPageSet.dischargingTrucking
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seDischargingTruckingTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabDischargingTrucking",
                                      label: _vm.$t(
                                        "SeaExport.DispatchVehiclesAtDestination"
                                      )
                                    }
                                  },
                                  [
                                    _c("tab-discharging-trucking-UICustom", {
                                      ref: "tabDischargingTrucking",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.currentRow.destPortCustomsClearance
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "tabDestinationCustomsData",
                                    attrs: {
                                      lazy: true,
                                      name: "tabDestinationCustomsData",
                                      label: _vm.$t(
                                        "SeaExport.PortOfDestinationCustomsClearance"
                                      )
                                    }
                                  },
                                  [
                                    _c("tab-destination-customs-data", {
                                      ref: "tabDestinationCustomsData",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action,
                                        "force-readonly": true
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm.currentRow.customs &&
                            _vm.seUiCustomShowPageSet.customs
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seCustomsTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabCustomsInfo",
                                      label: _vm.$t(
                                        "SeaExport.CustomsDeclaration"
                                      )
                                    }
                                  },
                                  [
                                    _c("tab-customs-info-UICustom", {
                                      ref: "tabCustomsInfo",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.$checkPermission(["role_SalesQueryModule_charge"])
                        ? [
                            _vm.seUiCustomEnable || _vm.aeUiCustomEnable
                              ? [
                                  !_vm.chargePageSet.hideTabCharge
                                    ? _c(
                                        "el-tab-pane",
                                        {
                                          key: "tabCharges",
                                          attrs: {
                                            name: "tabCharges",
                                            lazy: !_vm.isSalesForSzfs,
                                            label: _vm.$t("CargoMsg.Cargo_Cost")
                                          }
                                        },
                                        [
                                          _c("tab-charges", {
                                            ref: "tabCharges",
                                            attrs: {
                                              context: _vm.context,
                                              action: _vm.action,
                                              adjust: true,
                                              "view-source": "salesDetail",
                                              "sale-role-hide":
                                                _vm.saleRoleHide,
                                              "customer-sales-display":
                                                _vm.customerSalesDisplay,
                                              "enable-ui-custom":
                                                _vm.chargePageSet
                                                  .arShowInSalesInquiry
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.chargePageSet.arAloneShow &&
                                  _vm.$checkPermission([
                                    "tab_Charge_chargeReceivable"
                                  ])
                                    ? _c(
                                        "el-tab-pane",
                                        {
                                          key: "tabChargesAr",
                                          attrs: {
                                            name: "tabChargesAr",
                                            lazy: !_vm.isSalesForSzfs,
                                            label: _vm.$t(
                                              "queryJob.FeeReceivable"
                                            )
                                          }
                                        },
                                        [
                                          _c("tab-charges", {
                                            ref: "tabChargesAr",
                                            attrs: {
                                              context: _vm.context,
                                              action: _vm.action,
                                              adjust: true,
                                              "view-source": "salesDetail",
                                              "sale-role-hide":
                                                _vm.saleRoleHide,
                                              "customer-sales-display":
                                                _vm.customerSalesDisplay,
                                              "tab-name": "tabChargesAr",
                                              type: "ar",
                                              "enable-ui-custom":
                                                _vm.chargePageSet
                                                  .arShowInSalesInquiry
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.chargePageSet.apAloneShow &&
                                  _vm.$checkPermission([
                                    "tab_Charge_chargePayable"
                                  ])
                                    ? _c(
                                        "el-tab-pane",
                                        {
                                          key: "tabChargesAp",
                                          attrs: {
                                            name: "tabChargesAp",
                                            lazy: !_vm.isSalesForSzfs,
                                            label: _vm.$t(
                                              "queryJob.CostsPayable"
                                            )
                                          }
                                        },
                                        [
                                          _c("tab-charges", {
                                            ref: "tabChargesAp",
                                            attrs: {
                                              context: _vm.context,
                                              action: _vm.action,
                                              adjust: true,
                                              "view-source": "salesDetail",
                                              "sale-role-hide":
                                                _vm.saleRoleHide,
                                              "customer-sales-display":
                                                _vm.customerSalesDisplay,
                                              "tab-name": "tabChargesAp",
                                              type: "ap",
                                              "enable-ui-custom":
                                                _vm.chargePageSet
                                                  .apShowInSalesInquiry
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              : [
                                  _c(
                                    "el-tab-pane",
                                    {
                                      key: 7,
                                      attrs: {
                                        name: "tabCharges",
                                        lazy: !_vm.isSalesForSzfs,
                                        label: _vm.$t("CargoMsg.Cargo_Cost")
                                      }
                                    },
                                    [
                                      _c("tab-charges", {
                                        ref: "tabCharges",
                                        attrs: {
                                          context: _vm.context,
                                          action: _vm.action,
                                          adjust: true,
                                          "view-source": "salesDetail",
                                          "sale-role-hide": _vm.saleRoleHide,
                                          "customer-sales-display":
                                            _vm.customerSalesDisplay
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                          ]
                        : _vm._e(),
                      _vm.$checkPermission([
                        "role_SalesQueryModule_billTabView"
                      ]) && !_vm.isSalesForSzfs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 8,
                              attrs: {
                                name: "tabInternalBill",
                                lazy: true,
                                label: _vm.$t("CargoMsg.Cargo_DomesticBill")
                              }
                            },
                            [
                              _c("tab-internal-bill", {
                                ref: "tabInternalBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "salesDetail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.$checkPermission([
                        "role_SalesQueryModule_BillingPrint"
                      ]) && !_vm.isSalesForSzfs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 9,
                              attrs: {
                                name: "tabOverseaBill",
                                lazy: true,
                                label: _vm.$t(
                                  "CargoMsg.Cargo_InternationalBill"
                                )
                              }
                            },
                            [
                              _c("tab-oversea-bill", {
                                ref: "tabOverseaBill",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "salesDetail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 10,
                              attrs: {
                                name: "tabFile",
                                lazy: true,
                                label: _vm.$t("SeaExport.DocumentCirculation")
                              }
                            },
                            [
                              _c("tab-file", {
                                ref: "tabFile",
                                attrs: {
                                  context: _vm.context,
                                  "show-button": false,
                                  "view-source": "salesDetail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 11,
                              attrs: {
                                name: "salesWarehouseIn",
                                lazy: true,
                                label: _vm.$t("SeaExport.CargoInfo")
                              }
                            },
                            [
                              _c("sales-warehouse-in", {
                                ref: "salesWarehouseIn",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  "view-source": "salesDetail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.isSalesForSzfs
                        ? _c(
                            "el-tab-pane",
                            {
                              key: 12,
                              attrs: {
                                name: "tabAdvanceCharge",
                                lazy: true,
                                label: _vm.$t(
                                  "CargoMsg.Cargo_AdvanceChargeInfo"
                                )
                              }
                            },
                            [
                              _c("tab-advance-charge", {
                                ref: "tabAdvanceCharge",
                                attrs: {
                                  context: _vm.context,
                                  action: _vm.action,
                                  adjust: false,
                                  "view-source": "salesDetail"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          key: 13,
                          attrs: {
                            name: "tabSopState",
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_BusinessStatus")
                          }
                        },
                        [
                          _c("tab-sop-state", {
                            ref: "tabSopState",
                            attrs: {
                              context: _vm.context,
                              action: _vm.action,
                              "view-source": "salesDetail"
                            }
                          })
                        ],
                        1
                      ),
                      _vm.seUiCustomEnable
                        ? [
                            !_vm.masterFlag &&
                            _vm.currentRow.cargoType &&
                            _vm.currentRow.cargoType !== "GC" &&
                            _vm.seUiCustomShowPageSet.specialGoods
                              ? _c(
                                  "el-tab-pane",
                                  {
                                    key: "seSpecialGoodsTab",
                                    attrs: {
                                      lazy: true,
                                      name: "tabSpecialGoods",
                                      label: _vm.$t("SpecialGoods.label")
                                    }
                                  },
                                  [
                                    _c("tab-special-goods-UICustom", {
                                      ref: "tabSpecialGoods",
                                      attrs: {
                                        context: _vm.context,
                                        action: _vm.action
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.$checkPermission(["role_SalesQueryModule_FileTab"])
                        ? [
                            _vm.seUiCustomEnable
                              ? [
                                  _vm.seUiCustomShowPageSet.fileHistory
                                    ? _c(
                                        "el-tab-pane",
                                        {
                                          key: "seFileHistoryTab",
                                          attrs: {
                                            name: "tabFileHistory",
                                            lazy: true,
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_FileHistory"
                                            )
                                          }
                                        },
                                        [
                                          _c("tab-file-history", {
                                            ref: "tabFileHistory",
                                            attrs: {
                                              context: _vm.context,
                                              "view-source": "salesDetail"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              : [
                                  _c(
                                    "el-tab-pane",
                                    {
                                      key: 14,
                                      attrs: {
                                        name: "tabFileHistory",
                                        lazy: true,
                                        label: _vm.$t(
                                          "CargoMsg.Cargo_FileHistory"
                                        )
                                      }
                                    },
                                    [
                                      _c("tab-file-history", {
                                        ref: "tabFileHistory",
                                        attrs: {
                                          context: _vm.context,
                                          "view-source": "salesDetail"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ]
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ],
                1
              )
            ])
          ])
        ],
        2
      ),
      _c("cargo-template-select-dialog", {
        ref: "templateSelectorDialog",
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.ctx,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data,
          context: _vm.context,
          "pre-print-callback": _vm.prePrintCallback,
          "printed-callback": _vm.printedCallback,
          "v2-check-callback": _vm.v2CheckCallback
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      }),
      _vm.saleInfoDialog.visible
        ? _c(
            "el-dialog",
            {
              directives: [
                { name: "el-drag-dialog", rawName: "v-el-drag-dialog" }
              ],
              attrs: {
                visible: _vm.saleInfoDialog.visible,
                title: _vm.$t("CargoMsg.Cargo_EditSaleInfo"),
                width: "360px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  return _vm.$set(_vm.saleInfoDialog, "visible", $event)
                }
              }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "85px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.UserDefinedField1") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        attrs: { no: "5", type: "textarea", rows: 5 },
                        model: {
                          value: _vm.saleInfoDialog.userDefinedField1,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.saleInfoDialog,
                              "userDefinedField1",
                              $$v
                            )
                          },
                          expression: "saleInfoDialog.userDefinedField1"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.quotationNum") } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "195px" },
                        attrs: { no: "6" },
                        model: {
                          value: _vm.saleInfoDialog.quotationNum,
                          callback: function($$v) {
                            _vm.$set(_vm.saleInfoDialog, "quotationNum", $$v)
                          },
                          expression: "saleInfoDialog.quotationNum"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticStyle: { margin: "0 auto", width: "fit-content" },
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { no: "7", type: "primary" },
                      on: { click: _vm.toEditSaleInfoConfirm }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "8" },
                      on: {
                        click: function($event) {
                          _vm.saleInfoDialog.visible = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.unlockApplyDialog.visible
        ? _c("unlock-apply-dialog", {
            attrs: {
              visible: _vm.unlockApplyDialog.visible,
              "selected-jobs": [_vm.currentRow]
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.unlockApplyDialog, "visible", $event)
              },
              success: _vm.onUnlockApplySuccess
            }
          })
        : _vm._e(),
      _c("custom-form-window", {
        ref: "customFormWindow",
        on: { instructionCallback: _vm.onInstructionCallback }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }